"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NDefaultTypeCoder = exports.typeMapping = void 0;
var guid_typescript_1 = require("guid-typescript");
exports.typeMapping = {
    date: 'io.avail.std.datetime.v1',
    uuid: 'io.avail.std.uuid.v1'
};
var NDefaultTypeCoder = /** @class */ (function () {
    function NDefaultTypeCoder() {
    }
    NDefaultTypeCoder.typeCoding = function (obj) {
        if (obj instanceof Date) {
            return exports.typeMapping.date;
        }
        else if (obj instanceof guid_typescript_1.Guid) {
            return exports.typeMapping.uuid;
        }
        return undefined;
    };
    return NDefaultTypeCoder;
}());
exports.NDefaultTypeCoder = NDefaultTypeCoder;
//# sourceMappingURL=NDefaultTypeCoder.js.map